import { cn } from '@shared/lib/cn'

interface ErrorMessageProps {
  message?: string
  className?: string
}

export function ErrorMessage({ message, className }: ErrorMessageProps) {
  if (!message) return null
  return <p className={cn('typo-tag text-red', className)}>{message}</p>
}
